import { Fragment, useRef } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import ButtonWLoading from '../button-w-loading'
import { BrandLogo } from '@/components/icons'
import NextLink from 'next/link'

const Modal = ({
  type,
  isOpen,
  onClose,
  onConfirm,
  isLoadingConfirmBtn = false,
  withPadding = false,
  content,
  isStudent,
  title,
  secondTitle,
  trigger,
  button1Text = 'Delete',
  button2Text = 'Cancel',
  cancelButton = true,
  deleteButton = true,
  withFooter = true,
  withHeader = true,
  withViselyLogo = true,
  maxWidth = '',
  minWidth = null,
  isButton = true,
  titleStyles,
  withCloseButton = true,
  customBodyPadding = '',
  customZIndex = '99999',
}) => {
  const cancelButtonRef = useRef(null)

  const triggerHandler = () => {
    onClose(false)
    trigger(true)
  }

  const CloseButtonSvg = () => {
    return (
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 1L1 11M1 1L11 11"
          stroke="#444CE7"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }

  return (
    <>
      <Transition.Root show={isOpen} as={Fragment}>
        <Dialog
          as="div"
          className={`relative z-[${customZIndex}]`}
          initialFocus={cancelButtonRef}
          onClose={onClose}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 z-30 transition-opacity bg-v8-ink/75" />
          </Transition.Child>

          <div className="fixed inset-0 z-30 overflow-y-auto">
            <div className="flex justify-center min-h-full p-4 text-center items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel
                  className={`relative ${
                    !!maxWidth ? maxWidth : 'w-full sm:w-[622px]'
                  } ${withPadding ? '' : 'px-4 sm:p-6'}  ${
                    customBodyPadding ? customBodyPadding : 'pt-5 pb-4'
                  } overflow-hidden text-left transition-all transform bg-white rounded-v8 border border-v8-line shadow-v8-card sm:my-8`}
                >
                  <div>
                    {withCloseButton && (
                      <div className="flex justify-end">
                        <span className="cursor-pointer" onClick={onClose}>
                          <CloseButtonSvg />
                        </span>
                      </div>
                    )}
                    <div className="text-center">
                      <div className="flex justify-center">
                        {/* <Image
                          src={mainLogo}
                          alt="logo"
                          className="flex justify-center"
                        /> */}
                        {withViselyLogo && (
                          <NextLink href="/" className="flex mb-4 focus:outline-none">
                            <span className="sr-only">ExamSolutions Logo</span>
                            <div className="flex flex-shrink-0 items-center">
                              <BrandLogo />
                            </div>
                          </NextLink>
                        )}
                      </div>
                      {withHeader && (
                        <Dialog.Title
                          as="h3"
                          className={`flex flex-col items-center justify-center ${
                            titleStyles
                              ? titleStyles
                              : 'pb-2 text-2xl sm:text-3xl font-semibold leading-6 text-v8-ink'
                          } `}
                        >
                          {title}
                          <span className="text-base font-normal text-v8-mut">
                            {secondTitle}
                          </span>
                        </Dialog.Title>
                      )}
                      <div className={`${withHeader ? 'mt-2' : ''}`}>
                        <div className="text-sm text-v8-mut">{content}</div>
                      </div>
                    </div>
                  </div>
                  {withFooter && (
                    <div
                      className={`mt-5 sm:mt-6  ${
                        deleteButton && cancelButton
                          ? 'sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense'
                          : 'flex flex-col space-y-2 justify-center items-center sm:w-[480px] mx-auto'
                      }`}
                    >
                      {type === 'signup' || type === 'signin' ? (
                        <>
                          {deleteButton && isButton && !isStudent && (
                            <ButtonWLoading
                              isPending={isLoadingConfirmBtn}
                              text={button1Text}
                              type="button"
                              className="inline-flex col-span-2 justify-center w-full px-4 py-[11px] text-base font-medium text-white bg-v8-blue border border-transparent rounded-md shadow-sm hover:bg-v8-blue focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:col-start-2 sm:text-sm"
                              onClick={onConfirm}
                            />
                          )}
                        </>
                      ) : (
                        ''
                      )}

                      {cancelButton && (
                        <button
                          type="button"
                          className="inline-flex col-span-2 justify-center w-full px-4 py-[11px] mt-3 text-base font-medium text-v8-ink bg-white border border-v8-line rounded-md shadow-sm hover:bg-v8-blue/5 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                          onClick={onClose}
                          ref={cancelButtonRef}
                        >
                          {button2Text}
                        </button>
                      )}

                      {type === 'signup' || type === 'book' ? (
                        <p className="text-[#475467] sm:w-[422px] text-center py-2 text-sm font-normal">
                          By signing up, you agree to Terms of Use and Privacy
                          Policy
                        </p>
                      ) : (
                        ''
                      )}

                      {type === 'signup' || type === 'book' ? (
                        <div className="text-[#475467] text-sm font-normal">
                          Already have an account?{' '}
                          <button
                            onClick={triggerHandler}
                            className="font-semibold outline-none text-v8-blue"
                          >
                            Sign in
                          </button>
                        </div>
                      ) : type === 'signin' ? (
                        <div className="text-[#475467] text-sm font-normal pt-4">
                          Don’t have account?{' '}
                          <button
                            onClick={triggerHandler}
                            className="font-semibold outline-none text-v8-blue"
                          >
                            Sign up
                          </button>
                        </div>
                      ) : (
                        ''
                      )}
                    </div>
                  )}
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  )
}

export default Modal
